import { IModel, ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { APPlannedCourse } from '../../../builders/ap_planned_course_builder';
import { INVALID_ID } from '../../../constants/ap_id_constants';
import { ap_course_status_type } from '../../../strategies/ap_course_status_strategy';
import { APCourse } from './../../../builders/ap_course_builder';
import { APProgramSlot } from './../../../builders/ap_program_slot_builder';

interface IStudentCourse {
  id?: number;
  term: number;
  course: number;
  status: ap_course_status_type;
}
export interface IAPCourseRequisite {
  course: number;
  id: number;
  level: number;
  test: string;
  title: string;
  type: string;
  _course?: CourseRequisite;
  range: string;
  is_course_satisfied: boolean;
  is_grade_satisfied: boolean;
}

export type AssociatedCourse = Record<string, APCourse>;
export type CourseRequisite = Record<string, IAPCourseRequisite>;

export type APCourseDetailCourse = APCourse & {
  prereq_instruction?: string;
};

export interface IAPCourseInfoModel {
  termId: number;
  course: Record<string, APCourseDetailCourse>;
  associated_course?: AssociatedCourse;
  coreq: CourseRequisite;
  prereq: CourseRequisite;
  planned_course: Record<string, APPlannedCourse>;
  student_course: Record<string, IStudentCourse>;
  programSlot?: APProgramSlot['id'];
}

export type APCourseInfoModel = ITypedModel<IAPCourseInfoModel>;

angular.module('capability-ng-academic-planner').factory('ngAPCourseInfoModel', (): APCourseInfoModel => {
  return new Model<IAPCourseInfoModel>({
    termId: INVALID_ID,
    course: {} as Record<string, APCourse>,
    associated_course: undefined,
    planned_course: {},
    student_course: {},
    programSlot: undefined,
    coreq: {},
    prereq: {}
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/models/course_info_model.ts